<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="width: 100%;">Doctors by Case Statuses</h3>
        <input type="checkbox" id="checkbox" v-model="isStacked">
        <label for="checkbox">Stacked by Specialization</label>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in doctors" :key="item.id">
            <h4>{{item.name}}</h4>
            <v-layout row wrap>
              <v-flex xs4>
                <bar-chart :chartData="item.specializationBar" :chart-id="item.id" style="min-height: 400px" :options="optionsBar"></bar-chart>
              </v-flex>
              <v-flex xs4>
                <bar-chart :chartData="item.ownerBar" :chart-id="item.id" style="min-height: 400px" :options="generalOptionsBar"></bar-chart>
              </v-flex>
              <v-flex xs4>
                <bar-chart :chartData="item.collaboratorBar" :chart-id="item.id" style="min-height: 400px" :options="generalOptionsBar"></bar-chart>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>

<script>
import BarChart from '../Charts/Bar'
import api from '../../api'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'cases',
  components: {
    BarChart
  },
  data() {
    return {
      loading: false,
      blackList: [
        '0fac6973-bb99-469e-91ab-bc70dd5a7a56',
        '909ffdfc-47c1-4b4d-88af-43da7d6a106e',
        'ea1a53e1-2ae2-4b43-aa04-79782e957409',
        '6895eef3-1fd4-4844-8230-96a51ab0396d',
        '0706cc6f-9472-45e1-b7bc-feabf1418666',
        'bed74ed7-2393-4baa-ad45-a0bfc01370e7',
        '3ad1337e-6a24-4e75-8c37-fba762247e30',
        '12c861bd-64c0-4a7f-9942-65523d8995b9',
        'b7f08e03-d367-4663-a68e-47e5e0715f02',
        '61b65bb4-f8e3-46f7-8d1a-5baad1860b3f',
        '398c2914-b799-4cc0-9d0f-6544982a6a8f',
        '124b640f-5353-4be6-9415-953a9a148072',
        '132db277-1f47-4578-987a-40924e88a1d8'
      ],
      doctors: [],
      doctorsTotal: [],
      doctorsStacked: [],
      isStacked: false,
      generalOptionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        scales:
          {
            yAxes: [
              {
                ticks:
                  {
                    beginAtZero: true,
                    suggestedMax: 100
                  }
              }]
          }
      },
      optionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        scales:
          {
            yAxes: [
              {
                ticks:
                  {
                    beginAtZero: true,
                    suggestedMax: 100
                  }
              }]
          }
      }
    }
  },
  created() {
    try {
      this.getDiagnosticPerformance()
    } catch (e) {
      this.showApiError(this, e, 'Unable to draw charts')
    }
  },
  watch: {
    isStacked: function() {
      if (this.isStacked === true) {
        this.doctors = this.doctorsStacked
        this.optionsBar = {
          responsive: true,
          maintainAspectRatio: false,
          scales:
            {
              yAxes: [
                {
                  stacked: true,
                  ticks:
                    {
                      beginAtZero: true,
                      suggestedMax: 100
                    }
                }],
              xAxes: [{
                stacked: true
              }]
            }
        }
      } else {
        this.doctors = this.doctorsTotal
        this.optionsBar = {
          responsive: true,
          maintainAspectRatio: false,
          scales:
            {
              yAxes: [
                {
                  ticks:
                    {
                      beginAtZero: true,
                      suggestedMax: 100
                    }
                }]
            }
        }
      }
    }
  },
  methods: {
    stringToColour(str) {
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }
      let colour = '#'
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF
        colour += ('00' + value.toString(16)).substr(-2)
      }
      return colour
    },
    async getDiagnosticPerformance() {
      this.loading = true

      let result = await api.getDiagnosticPerformance()

      let caseSpecialization = result.caseSpecialization
      let caseOwner = result.caseOwner
      let caseColoborator = result.caseColoborator

      let specializationDict = []
      for (let item of caseSpecialization) {
        if (specializationDict.indexOf(item.specialization) === -1) {
          specializationDict.push(item.specialization)
        }
      }

      specializationDict = _.sortBy(specializationDict)

      let doctorDict = []
      let doctorDictIds = []
      for (let item of caseSpecialization) {
        if (this.blackList.indexOf(item.owner_doctor_id) > -1) {
          continue
        }
        if (doctorDictIds.indexOf(item.owner_doctor_id) === -1) {
          doctorDictIds.push(item.owner_doctor_id)
          doctorDict.push({
            id: item.owner_doctor_id,
            name: item.user_name,
            total: _.filter(result, (o) => { if (o.owner_doctor_id === item.owner_doctor_id) return o }).length })
        }
      }

      doctorDict = _.orderBy(doctorDict, ['total'], ['desc'])

      for (let doctor of doctorDict) {
        let dataTotal = []
        let dataStacked = []

        dataTotal.push({
          label: 'Total by Cases Status',
          backgroundColor: '#29B6F6',
          data: [
            _.filter(caseSpecialization, (o) => { if (o.owner_doctor_id === doctor.id && o.status === 'materials_preparing') return o }).length,
            _.filter(caseSpecialization, (o) => { if (o.owner_doctor_id === doctor.id && o.status === 'ready_for_diagnostics') return o }).length,
            _.filter(caseSpecialization, (o) => { if (o.owner_doctor_id === doctor.id && o.status === 'report_in_progress') return o }).length
          ]})

        for (let s of specializationDict) {
          dataStacked.push({
            label: s,
            backgroundColor: this.stringToColour(s),
            data: [
              _.filter(caseSpecialization, (o) => { if (o.owner_doctor_id === doctor.id && o.status === 'materials_preparing' && o.specialization === s) return o }).length,
              _.filter(caseSpecialization, (o) => { if (o.owner_doctor_id === doctor.id && o.status === 'ready_for_diagnostics' && o.specialization === s) return o }).length,
              _.filter(caseSpecialization, (o) => { if (o.owner_doctor_id === doctor.id && o.status === 'report_in_progress' && o.specialization === s) return o }).length
            ]})
        }

        let lastMonth = Array.apply(null, Array(31)).map((_, i) => { return moment().subtract(i, 'days').format('YYYY-MM-DD') })
        lastMonth.reverse()

        let ownerDataset = Array.apply(0, Array(31))
        let coloboratorsDataset = Array.apply(0, Array(31))

        for (let item of caseOwner) {
          if (item.name === doctor.name) {
            let i = lastMonth.indexOf(item.creation_date)
            ownerDataset[i] = item.count
          }
        }

        for (let item of caseColoborator) {
          if (item.name === doctor.name) {
            let i = lastMonth.indexOf(item.creation_date)
            coloboratorsDataset[i] = item.count
          }
        }

        this.doctorsTotal.push({
          id: doctor.id,
          name: doctor.name,
          specializationBar: {
            labels: ['Preparing', 'Ready', 'In progress'],
            datasets: dataTotal
          },
          ownerBar: {
            labels: lastMonth,
            datasets: [{
              label: 'Responsible by Date, Cases done',
              backgroundColor: '#29B6F6',
              data: ownerDataset
            }]
          },
          collaboratorBar: {
            labels: lastMonth,
            datasets: [{
              label: 'Collaborator by Date, Cases done',
              backgroundColor: '#29B6F6',
              data: coloboratorsDataset
            }]
          }
        })
        this.doctorsStacked.push({
          id: doctor.id,
          name: doctor.name,
          specializationBar: {
            labels: ['Preparing', 'Ready', 'In progress'],
            datasets: dataStacked
          },
          ownerBar: {
            labels: lastMonth,
            datasets: [{
              label: 'Responsible by Date, Cases done',
              backgroundColor: '#29B6F6',
              data: ownerDataset
            }]
          },
          collaboratorBar: {
            labels: lastMonth,
            datasets: [{
              label: 'Collaborator by Date, Cases done',
              backgroundColor: '#29B6F6',
              data: coloboratorsDataset
            }]
          }
        })
      }
      this.doctors = this.doctorsTotal
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Diagnostics/Performance.vue